module.exports = __webpack_public_path__ + "img/background059.jpg";